import { useQuery, UseQueryOptions } from 'react-query';
import { UserPreview } from '@bizzabo/entities';
import client from 'client';
import { MeetingsHttpKey } from '../ManageMeetings/useMeetingsData';

type UserSearchResponse = {
    content: UserPreview[];
    links: {
        rel: string;
        href: string;
    }[];
    page: Page;
};

type Page = {
    size: number;
    totalElements: number;
    totalPages: number;
    number: number;
};

type Order = 'ASC' | 'DESC';

export enum FieldType {
    EVENT_ID = 'EVENT_ID',
    USER_PROFILE_ID = 'USER_PROFILE_ID',
}

type Criteria = {
    field: FieldType;
    value: number | number[] | boolean;
    action: string;
};

export type Payload = {
    page: number;
    size: number;
    orders: {
        FIRST_NAME: Order;
        LAST_NAME: Order;
    };
    criteria: (Criteria | string)[];
};

const userSearch = async (eventId: number, payload: Payload) => {
    const response = await client().post<UserSearchResponse>(
        `api/v2/people/events/${eventId}/userSearch`,
        payload
    );

    return response.data;
};

const useUsersSearch = ({
    eventId,
    payload,
    options,
}: {
    eventId: number;
    payload: Payload;
    options?: UseQueryOptions<UserSearchResponse>;
}) => {
    return useQuery<UserSearchResponse>(
        [MeetingsHttpKey.MeetingsUsers, payload.size],
        () => userSearch(eventId, payload),
        {
            ...options,
        }
    );
};

export default useUsersSearch;
